import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Api from 'service/api';
const currentYear = new Date().getFullYear().toString();
const useHolerite = () => {
    const [transitionIn, setTransitionIn] = useState(false);
    const [loadingForm, setLoadingForm] = useState(false);
    const [fieldErrors, setFieldErrors] = useState([]);
    const [messageAlertDownload, setMessageAlertDownload] = useState('');
    const [openMessage, setOpenMessage] = useState(false);
    const [contentModal, setContentModal] = useState({});
    // const [loadingModal, setLoadingModal] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [modalType, setModalType] = useState('');
    const [ano, setAno] = useState(currentYear);
    const [listHolerites, setListHolerites] = useState([]);
    const { t: translate } = useTranslation();

    document.title = translate('holerite.head.title');

    // Gera lista de anos dinamicamente a partir de 2023 até o ano atual
    const listAnos = (() => {
        const startYear = 2023;
        const currentYearNum = parseInt(currentYear);
        const years = [];

        for (let year = currentYearNum; year >= startYear; year--) {
            years.push({ label: year.toString(), value: year.toString() });
        }

        return years;
    })();

    const handleChangeAno = async (event) => {
        clearViewPdf();
        setAno(event.target.value);
        setFieldErrors(fieldErrors.filter((inp) => inp.name !== 'ano'));
        clearViewPdf();
        await getHolerites(event.target.value);
    };

    const clearViewPdf = () => {
        setListHolerites([]);
    };

    const handleOpenModal = (urlFile) => {
        setOpenModal(true);
        setContentModal({
            urlPdf: urlFile,
        });
    };

    const handleCloseModal = () => {
        setOpenModal(false);
        setContentModal({});
        setModalType('');
    };

    const getHolerites = async (anoSelected = null) => {
        setLoadingForm(true);
        if (!anoSelected) {
            anoSelected = ano;
        }
        try {
            const endPoint = `holerite/listar/${anoSelected}`;
            const response = await Api.get(endPoint);
            if (response.data.holerites.error) {
                setMessageAlertDownload(response.data.holerites.error);
                setOpenMessage(true);
                setLoadingForm(false);
                return;
            }

            if (response.data.holerites.length > 0) {
                const listData = response.data.holerites.map((item) => {
                    return item;
                });
                setListHolerites(listData);
            }

            setTimeout(() => {
                setOpenMessage(false);
            }, 3000);
        } catch (error) {
            console.error('Erro ao consultar o holerite:', error.message);
        }
        setLoadingForm(false);
    };

    useEffect(() => {
        (async () => {
            await getHolerites(ano);
        })();
    }, [ano]);

    setTimeout(() => {
        setTransitionIn(true);
    }, 300);

    return {
        transitionIn,
        listAnos,
        listHolerites,
        handleChangeAno,
        loadingForm,
        fieldErrors,
        messageAlertDownload,
        openMessage,
        translate,
        ano,
        handleOpenModal,
        handleCloseModal,
        contentModal,
        openModal,
        modalType,
        // loadingModal,
    };
};

export default useHolerite;
